import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';
import client from './client';
import customList from './custom-list';
import downloadRequest from './download-request';
import downloadRequestSearchOption from './download-request/search-option';
import visit from './visit';
import householdMemberColumn from './household-member-column';
import report from './report';
import reportTemplate from './report-template';
import permission from './permission';
import outreach from '../Outreach/reducers';
import inventory from '../Inventory/reducers';
import POS from '../POS/reducers';
import reservation from '../Reservation/reducers';
import guest from '../Guest/reducers';
import settings from '../Settings/reducers';
import views from './views';
import signature from './signature';
import mfaAuth from './mfa-auth';

import components from './components';

export default combineReducers({
  client,
  customList,
  downloadRequest,
  downloadRequestSearchOption,
  visit,
  householdMemberColumn,
  report,
  reportTemplate,
  permission,
  outreach,
  inventory,
  POS,
  reservation,
  guest,
  settings,
  views,
  components,
  toastr,
  signature,
  mfaAuth
});
